import { ApiResponse } from '../models/api/api-response.model';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from '../constants/api';

@Injectable({ providedIn: 'root' })
export class LicenseService {
  private readonly _http: HttpClient = inject(HttpClient);

  getLicensesListing({ page, limit }: { page: number; limit: number }) {
    return this._http.get<ApiResponse<any>>(API.licensesListing(page, limit), {
      withCredentials: true,
    });
  }

  getLicensesFullMinListing() {
    return this._http.get<ApiResponse<any>>(API.licensesFullMinListing(), {
      withCredentials: true,
    });
  }

  postLicense(data: any) {
    return this._http.post<ApiResponse<any>>(API.license(), data, {
      withCredentials: true,
    });
  }

  patchLicense(licenseId?: string, data?: any) {
    return this._http.patch<ApiResponse<any>>(
      API.licenseDetails(licenseId),
      data,
      { withCredentials: true }
    );
  }

  deleteLicense(licenseId?: string) {
    return this._http.delete<ApiResponse<any>>(API.licenseDetails(licenseId), {
      withCredentials: true,
    });
  }

  getLicenseDetails(licenseId?: string) {
    return this._http.get<ApiResponse<any>>(API.licenseDetails(licenseId), {
      withCredentials: true,
    });
  }

  getLicenseAssignmentsListing({
    licenseId,
    page,
    limit,
  }: {
    licenseId?: string;
    page: number;
    limit: number;
  }) {
    return this._http.get<ApiResponse<any>>(
      API.licenseAssignmentsListing(licenseId, page, limit),
      { withCredentials: true }
    );
  }

  getLicenseAssignmentDetails(licenseAssignmentId?: string) {
    return this._http.get<ApiResponse<any>>(
      API.licenseAssignmentDetails(licenseAssignmentId),
      { withCredentials: true }
    );
  }

  postLicenseAssignment(data?: any) {
    return this._http.post<ApiResponse<any>>(API.licenseAssignment(), data, {
      withCredentials: true,
    });
  }

  patchLicenseAssignment(licenseAssignmentId?: string, data?: any) {
    return this._http.patch<ApiResponse<any>>(
      API.licenseAssignmentDetails(licenseAssignmentId),
      data,
      { withCredentials: true }
    );
  }

  deleteLicenseAssignment(licenseAssignmentId?: string) {
    return this._http.delete<ApiResponse<any>>(
      API.licenseAssignmentDetails(licenseAssignmentId),
      { withCredentials: true }
    );
  }

  syncLicenseAssignments(licenseId?: string) {
    return this._http.get<ApiResponse<any>>(
      API.syncLicenseAssignments(licenseId),
      { withCredentials: true }
    );
  }
}
